export const formatDate = (date: Date): string => {
    if (!date) return null

    return `${`0${date.getDate()}`.slice(-2)}.${`0${date.getMonth() + 1}`.slice(
        -2
    )}.${date.getFullYear()}`
}

export const formatPhoneNumber = (
    number: string,
    defaultGapSize = 2
): string => {
    let result = ''
    let cloned = number

    // Desired distance between spaces
    const gap_size = defaultGapSize

    while (cloned.length > 0) {
        // Loop through string
        result = `${result} ${cloned.substring(0, gap_size)}` // Insert space character
        cloned = cloned.substring(gap_size) // Trim String
    }

    return result
}
